<template>
  <div>
    <div>
      <div v-if="loaded && adminGiftCards.length === 0">
        <div class="alert alert-primary" role="alert">
          کارت هدیه ای یافت نشد، برای افزودن کارت هدیه
          <router-link
            :to="{ name: 'admin-gift-cards-create' }"
            class="alert-link text-light-primary"
          >
            کلیک
          </router-link>
          کنید
        </div>
      </div>
    </div>

    <div
      v-if="loaded && adminGiftCards.length"
      class="card card-custom gutter-b"
    >
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>عنوان</th>
                <th>کد</th>
                <th>قیمت</th>
                <th>وضعیت</th>
                <th>تاریخ ایجاد</th>
                <!-- <th>تاریخ پایان</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="giftcard in adminGiftCards" :key="giftcard.id">
                <td class="text-nowrap">{{ giftcard.title }}</td>
                <td>{{ giftcard.code }}</td>
                <td dir="ltr">{{ numberFormat(giftcard.value) }}</td>
                <td class="text-nowrap">
                  {{ giftCardsTypes[giftcard.status] }}
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(giftcard.created_at) }}
                </td>
                <!-- <td dir="ltr" class="text-nowrap">
                  {{ formatDate(giftcard.updated_at) }}
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="overflow-auto mt-5"
      v-if="adminGiftCardsPagination.lastPage > 1"
    >
      <b-pagination
        v-model="adminGiftCardsPagination.currentPage"
        :total-rows="adminGiftCardsPagination.total"
        :per-page="adminGiftCardsPagination.perPage"
        aria-controls="my-table"
        @input="updateGiftCards()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_ADMIN_GIFT_CARDS } from "@/core/services/store/admin/giftcards.module";
import { mapGetters } from "vuex";

export default {
  name: "programs",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "کارت هدیه" }]);

    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "admin-gift-cards-create" },
          class: "btn-primary"
        }
      ]
    });
    this.updateGiftCards();
  },
  computed: {
    ...mapGetters([
      "adminGiftCards",
      "adminGiftCardsPagination",
      "giftCardsTypes"
    ])
  },
  methods: {
    updateGiftCards() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_GIFT_CARDS)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
